import { PostAuthor } from '@bridebook/toolbox/src/schemas/article/types';

export const useAuthorMeta = (authorDetails?: PostAuthor) => {
  const defaultTitle = `${authorDetails?.display_name}${authorDetails?.bb_job_title ? ` | ${authorDetails.bb_job_title}` : ''} | Bridebook`;

  const metaTitle = authorDetails?.seo_title || defaultTitle;
  const metaDescription = authorDetails?.seo_metadesc || '';

  const authorImg = authorDetails?.profile_image?.full || '';
  const ogImage = authorDetails?.bb_og_image || authorImg;

  return {
    metaTitle,
    metaDescription,
    ogImage,
  };
};
